import React, { useState } from "react";

import { useNavigate } from "react-router-dom";

import imageOne from '../../resource/donations/life-long/1.png'
import imageTwo from '../../resource/donations/life-long/3.png'
import imageFour from '../../resource/donations/life-long/4.png'
import imageFive from '../../resource/donations/life-long/5.png'
import imageThree from '../../resource/donations/life-long/2.png'
import imageSix from '../../resource/donations/life-long/5 (3).png'
import TitleChnage from '../../Hook/TitleChnage'

const LifeLongMembership = () => {
    TitleChnage("Life Long Membership");
     const navigate = useNavigate();
      const handleClick = (event) => {
        const pathMap = {
            liveLongMembershoipForm: "/liveLongMembershoipForm",
            lifeLongReq:"/lifeLongReq"
            
        };
    
        const path = event.currentTarget.id;
        const targetPath = pathMap[path];
    
        if (targetPath) {
          navigate(targetPath);
        }
      };
  return (
    <div className="lifelong-page inside-pages">
    <div className="right-box">
        <img src={imageOne} alt="Right Top Image" className="right-image" width={300} />
    </div>

    <h1 className='font-main p-4 mt-4'>Lifelong Membership</h1>
<h3 className="font-second mt-4 p-4">"Yawa Jeewa Kappiyakaraka Dayakathwaya"</h3>
    
<div className="text-center mt-6 h4-bold p-4">
        <div>
            <p >A place to have a home with the Buddha. </p>
            <p >A place to practice living the Dhamma. </p>
            <p >A place to uplift the noble Sangha. </p>
            <p >A place to show respect—Isn't it a wonder?</p>

            <p >Make this place bright and shiny.</p>
            <p >Let your heart and mind be devoted to holy service.</p>
            <p >Devote your strength and memorize it daily.</p>
            <p >The gate to open the heaven of glory.</p>

        </div>
    </div>
    
    <p className="mt-6 h4 p-4">Bhaddeka Vihari Monastery and Meditation Centre is pleased to introduce the Lifelong Membership Fund for individuals who wish to make regular, monthly contributions to support the well-being of the Sangha and the Monastery.</p>
    <p className="mt-5 h4 p-4">Depending on your affordability, a lifelong monthly membership can begin at $20, $50, $100, $150, or $250. These contributions will support ongoing monthly expenses, including electricity, gas, fuel, internet and phone charges, as well as mortgage payments.</p>
    <p className="mt-5 h4 p-4">As the Sangha depends entirely on the generosity of the lay community, these donations are essential for sustaining their livelihood and ensuring the smooth operation of the Monastery. Your ongoing contributions play a crucial role in bridging financial gaps and supporting the continued activities and projects that benefit the spiritual growth of all.</p>
    <p className="mt-5 h4 p-4">Many donors have chosen to set up direct debit transactions through their financial institutions, allowing for a seamless and consistent contribution to the Monastery.</p>

<p className="mt-5 h4 p-4">By becoming a member of this Lifelong Membership Fund, you are helping to create a serene, inclusive, and thriving environment for spiritual practice. Your support will benefit not only the current community but also future generations.</p>

<p className="mt-5 h4 p-4">Contribute today to this noble cause and help us build a lasting foundation for spiritual growth, harmony, and well-being for the entire community.</p>
<p className="mt-5 h4 p-4">We are deeply grateful for your generous support.</p>

<div className="btn-group mt-6">
<img src={imageTwo} alt="Right Top Image" width={300}  id="liveLongMembershoipForm"
          onClick={handleClick}
          className="curser-pointer"/>
</div>
    <div className='btn-group2 mt-5'>
       
        <img src={imageFour} alt="Right Top Image" width={300} />
        <img src={imageFive} alt="Right Top Image" width={300} />
    </div>

    <div className="p-4 mt-6 text-center">
    <div className="mt-6 calander-box align-item-center">
            <div className="c-details text-left">
                <h2 className='intro-text '>Futher More Details : </h2>
                <p className="font-p mt-4">Monastery : 035608 0918 / 0459 729 738</p>
                <p className="font-p">Mr Gamini : 0422 069 359</p>
                <p className="font-p">WhatsApp : 0422 069 359</p>
                <p className="font-p">E-mail : info@bvp.org.au</p>
            </div>
            <div className="d-button">
                  <img
          src={imageSix}
          alt="Right Top Image"
          width={300}
          id="lifeLongReq"
         onClick={handleClick}
          className="curser-pointer"
        />
                    </div>
        </div>
        </div>

        <div className="bottom-box mt-6">
        <img src={imageThree} alt="bottom-image"  width={600} />
    </div>

</div>
  )
}

export default LifeLongMembership